import { KrLandslideFormTypes } from "../../contexts/krFormContext";
import { Option } from "../../components/shared/selectInput/types/selectInputProps";

export type tableRecord = {
    id?: number,
    rodzaj?: string,
    wiek?: string,
    zaleganie?: string
}

export const subsoilTableList = (krForm: KrLandslideFormTypes, rocksDict: Option[] | undefined, stratigraficDict: Option[] | undefined, rocksZalegDict: Option[] | undefined) => {
    var records: tableRecord[] = [];
    var rocksCopy = structuredClone(krForm?.rocks)
    rocksCopy?.sort((a, b) => a.kolejnosc! - b.kolejnosc!)
    var depositsCopy = structuredClone(krForm.rockDeposits);
    depositsCopy?.sort((a, b) => a.kolejnosc! - b.kolejnosc!)
    if (rocksCopy && rocksCopy.length > 0) {
        for (let i = 0; i < rocksCopy.length; i++) {
            var record: tableRecord = {};
            const rocks = rocksCopy[i];
            if (rocks.kolejnosc) record.id = rocks.kolejnosc - 1;
            let rodzaj = rocksDict?.find((option: Option) => {
                if (rocks) return option.value === rocks.skalY_RODZAJ_SID;
                return false;
            })?.name;
            record.rodzaj = rodzaj;
            if (rocks.stratygrafiA_OD_SID) {
                let stratygrafOD = stratigraficDict?.find((option: Option) => {
                    if (rocks) return option.value === rocks.stratygrafiA_OD_SID;
                    return false;
                })?.name;
                if (stratygrafOD) record.wiek = stratygrafOD
            }
            if (rocks.stratygrafiA_DO_SID) {
                let stratygrafDO = stratigraficDict?.find((option: Option) => {
                    if (rocks) return option.value === rocks.stratygrafiA_DO_SID;
                    return false;
                })?.name;
                if (stratygrafDO) record.wiek += " - " + stratygrafDO;
            }
            if (krForm.rockDeposits && krForm.rockDeposits.length > 0) {
                let rockDeposits = krForm.rockDeposits.filter((deposit) => {
                    if (rocksCopy) {
                        if (rocksCopy[i].globalid !== undefined) {
                            if (rocksCopy[i].globalid === deposit.osuwiskO_SKALA_GID) deposit.idx = i;
                            return rocksCopy[i].globalid === deposit.osuwiskO_SKALA_GID;
                        }
                    }
                    if (krForm.rockDeposits) return deposit.idx === i;
                    return false;
                })
                for (let j = 0; j < rockDeposits.length; j++) {
                    if (rocksZalegDict) {
                        var zalegania = rocksZalegDict?.find((option: Option) => {
                            if (rockDeposits) return option.value === rockDeposits[j].rodzaJ_ZALEGANIA_SKALY_SID;
                            return false;
                        })?.name;
                    }
                }
                var elements = krForm.rocksDepositAzimuths?.filter((azimuth) => {
                    if (azimuth.zaleganiE_SKALY_OSUWISKA_GID !== undefined && rockDeposits != null && rockDeposits.length > 0) {
                        var deposit = rockDeposits.find((opt) => {
                            return opt.globalid === azimuth.zaleganiE_SKALY_OSUWISKA_GID;
                        })
                        if (deposit) {
                            azimuth.idx = i;
                        }
                    }
                    if (krForm.rockDeposits) return azimuth.idx === i;
                    return false;
                })
                if (zalegania === "poziome" || zalegania === "brak możliwości obserwacji") {
                    elements = [];
                    record.zaleganie = zalegania;
                } else {
                    record.zaleganie = "";

                    if (elements && elements.length > 0) {
                        for (let k = 0; k < elements.length; k++) {
                            if (k === 0) record.zaleganie += (zalegania ? zalegania as string + " " : "");
                            if (_isSet(elements[k].azymut) && _isSet(elements[k].upad)) {
                                record.zaleganie += elements[k].azymut + "/" + elements[k].upad + ", ";
                            }
                        }
                        if (record.zaleganie.slice(-2) === ", ") record.zaleganie = record.zaleganie?.slice(0, record.zaleganie.length - 2);
                    }
                    else {
                        record.zaleganie += (zalegania ? zalegania as string : "");
                    }
                }
            }
            records.push(record);
        }
    }
    return records;
}

const _isSet = (value: any) => {
    return value !== null && value !== undefined && value !== "";
}